import { useEffect } from "react";
import { useRequestProcessor } from "../../requestProcessor";
import { App } from "@capacitor/app";
import { ReloadData } from "../../queryfunctions/queryfunctions";
import { useLocation, useNavigate } from "react-router-dom";

const Reload = () => {
    const location = useLocation()
    const navigate = useNavigate();
    const { useMutationWrapper } = useRequestProcessor();

    const reloadData = useMutationWrapper(
        "reload",
        () => ReloadData(),
        {
            onSuccess: (data) => {
                console.log("[Reload] Reload child data response:", data);
            },
        }
    );

    // -----------------------------
    // DATE CHECK
    // -----------------------------
    const check_date = (dateString) => {
        if (!dateString) return false;

        try {
            dateString = JSON.parse(dateString);
        } catch {
            console.log("Invalid stored date:", dateString);
            return false;
        }

        console.log("Checking date => ", dateString);

        const givenDate = new Date(dateString);
        const today = new Date();

        // Normalize both to date-only (ignore hours)
        givenDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        console.log("Given Date => ", givenDate, " === ", today);

        return givenDate.getTime() === today.getTime();
    };

    // -----------------------------
    // MAIN RELOAD LOGIC
    // -----------------------------
    const handleReload = async () => {
        console.log("[Reload] Running reload check on app start or resume...");

        const token = localStorage.getItem("auth_token");
        const reloadTime = localStorage.getItem("last_reload_time");
        const survey = localStorage.getItem("survey_id");

        console.log("[Reload] Auth Token:", token);
        console.log("[Reload] Reload Time:", reloadTime);
        console.log("[Reload] Survey ID:", survey);

        if (!reloadTime) {
            console.log("[Reload] No last_reload_time found. Skipping reload.");
            return;
        }

        if (token && token !== '""') {
            const shouldReload = !check_date(reloadTime);

            if (shouldReload) {
                console.log("[Reload] Date check failed. Reloading data...");
                reloadData.mutate();
            } else if (survey && survey > 0 && location.pathname !== "/survey") {
                console.log("[Reload] Redirecting to survey:", survey);
                navigate("/survey", { replace: true });
            } else {
                console.log("[Reload] No reload, no survey → doing nothing. shouldReload:", shouldReload, "survey:", survey);
            }
        } else {
            console.log("[Reload] No auth token. Removing listeners.");
            await App.removeAllListeners();
        }
    };

    // -----------------------------
    // SETUP LISTENER (Capacitor v5 fix)
    // -----------------------------
    useEffect(() => {
        console.log("[Reload] Setting up appStateChange listener...");

        let listenerRef;

        const setupListener = async () => {
            listenerRef = await App.addListener("appStateChange", ({ isActive }) => {
                console.log("[Reload] appStateChange =>", isActive);
                if (isActive) handleReload();
            });
        };

        setupListener();


        handleReload();

        return () => {
            console.log("[Reload] Cleaning up appStateChange listener...");
            if (listenerRef) listenerRef.remove();
        };
    }, []);

    return null;
};

export default Reload;
